import React from "react";
import { Checkbox, Checkmark, Container, Input } from "./style";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.ChangeEventHandler;
  checked?: boolean;
  error?: boolean;
  name?: string;
  disabled?: boolean;
  errors?: string;
  touched?: boolean;
  status?: "checked" | "indeterminate" | "none";
  label?: string;
};

export const CheckBox = ({
  onChange,
  onBlur,
  checked = false,
  disabled,
  error,
  errors,
  name,
  touched,
  status,
  label,
}: Props) => {
  const checkboxId = name ? `${name}-checkbox` : undefined;

  return (
    <Checkbox
      $error={!!(errors && touched) || error}
      $indeterminate={status === "indeterminate"}
    >
      <Container>
        <Input
          id={checkboxId} // Set the ID here
          disabled={disabled}
          type="checkbox"
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          checked={checked || (status && status !== "none")}
        />
        <Checkmark />
      </Container>
      {label && <label htmlFor={checkboxId}>{label}</label>}
    </Checkbox>
  );
};
